/**
 * ValidationReviewPage - Template validation error review and AI-assisted fixing
 *
 * Surfaces the ValidationReviewDashboard from @ferp/workflow-forms for admin/architect users.
 * Enables review and AI-assisted fixing of template validation errors.
 *
 * Route: /admin/validation-review
 */

import { Container, Title, Group, Badge, Text, ThemeIcon, Alert, Stack } from '@mantine/core';
import { IconChecks, IconInfoCircle } from '@tabler/icons-react';
import { ValidationReviewDashboard } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';
import { useSearchParams } from 'react-router-dom';

export function ValidationReviewPage() {
  const { tenant } = useAuth();
  const [searchParams] = useSearchParams();
  const templateId = searchParams.get('templateId');

  // If no template selected, show instruction
  if (!templateId) {
    return (
      <Container size="xl" py="md">
        <Group justify="space-between" mb="lg">
          <Group gap="sm">
            <ThemeIcon size="lg" variant="light" color="green">
              <IconChecks size={20} />
            </ThemeIcon>
            <div>
              <Title order={3}>Validation Review</Title>
              <Text size="sm" c="dimmed">
                Review and approve validation results across workflow executions
              </Text>
            </div>
          </Group>
          {tenant && (
            <Badge variant="light" color="gray">
              {tenant.name}
            </Badge>
          )}
        </Group>

        <Alert icon={<IconInfoCircle size={16} />} color="blue" variant="light">
          Select a template with validation errors to review. Navigate here from the Template Gallery
          or Workflow Studio when validation errors are detected.
        </Alert>
      </Container>
    );
  }

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="green">
            <IconChecks size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Validation Review</Title>
            <Text size="sm" c="dimmed">
              Review and approve validation results across workflow executions
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <ValidationReviewDashboard
        templateId={templateId}
        validationErrors={[]}
        onFixesApplied={(remainingErrors) => {
          console.log('Fixes applied, remaining errors:', remainingErrors);
        }}
      />
    </Container>
  );
}

export default ValidationReviewPage;
